import React from 'react'
import moment from 'moment'

import NavLink from '../Routes/NavLink'

import { leases } from '../../core/controllers/Leases'
import { multiTaskerManager } from '../../core/controllers/MultiTaskerManager'

export default class ExpiringLeasesWidget extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            totalExpiring: 0
        };

    }

    componentDidMount() {
        var self = this;
        leases.getExpiringLeasesForCurrentMonth(function(response) {
            self.setState({
                totalExpiring: response.data
            });
        });
    }

    componentWillUpdate(nextProps, nextState) {
    }

    openMultiTasker() {
        multiTaskerManager.setData(this.state.totalExpiring, 'expiringLeases');
        multiTaskerManager.forceUpdate();
    }

    render(){
        const totalExpiring = this.state.totalExpiring;
        return (
            <div class="col-md-4">
                <div class="card">
                    <div class="header">
                        <h4 class="title"><i class="icon-document-timer"></i><small><i class="pe-7s-angle-right"></i></small> Expiring Leases This Month</h4>
                        <p class="category"></p>
                    </div>
                    <div class="content">
                        <div class="row">
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label for="effective_date">Expiring Leases for { moment().format('MMMM') }</label>
                                    <input type="number" disabled class="form-control" value={totalExpiring} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="content">
                        <div class="footer">
                            <hr/>
                            <div class="legend">
                                <button type="button" data-loading-text="Loading..." class="btn btn-info btn-fill pull-right" onClick={this.openMultiTasker.bind(this)} autoComplete="off" >
                                View
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Leases/ExpiringLeasesWidget.jsx